// Posts the conversation to the assistant in backend/handler/assistant.js and calls
// onText with each chunk of the reply as it streams in.
// Resolves when the reply is complete or throws an Error carrying a user-facing message.
const FALLBACK =
  'Sorry, the assistant is unavailable right now. Please email info@astridfirst.com or call (+65) 6921 7700.';

export async function streamChat(messages, onText, signal) {
  let res;
  try {
    res = await fetch('/api/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages }),
      signal,
    });
  } catch (err) {
    if (err.name === 'AbortError') throw err;
    throw new Error(FALLBACK);
  }
  // Errors arrive as JSON; a reply is plain text. Static-only hosting answers
  // /api/chat with index.html, which must not be shown as a reply.
  const type = res.headers.get('Content-Type') || '';
  if (!res.ok || !type.startsWith('text/plain')) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || FALLBACK);
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let received = false;
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    const text = decoder.decode(value, { stream: true });
    if (text) {
      received = true;
      onText(text);
    }
  }
  if (!received) throw new Error(FALLBACK);
}
